import React, { useCallback } from "react";
import PageContainerAuth from "../components/common/PageContainerAuth";
import { Button } from "react-bootstrap";
import { useMsal } from "@azure/msal-react";
import { useNavigate } from "react-router-dom";

/**
 * PostLoginError component, the page displayed when an error occurs after login
 * 
 * @returns {JSX.Element} PostLoginError component
 */
export default function PostLoginError() {
    const {instance} = useMsal();
    const navigate = useNavigate();
  
  
    /**
     * Handles the logout button click event
     * it will trigger the logoutPopup method from the MSAL instance
     */
    const handleLogout = useCallback(() => {
      instance.logoutRedirect({ postLogoutRedirectUri: "/login" }).catch((error: any) => {
          console.error(error);
      });
      navigate("/");
    }, [instance,navigate]);

    return (
        <PageContainerAuth section="" pageTitle="Erreur lors de la connexion">
            <div>
                <p>Vous n'avez pas le droit de consulter cette application</p>
                <Button onClick={handleLogout} className="signout">
                    <span className="icon"></span>
                    <span className="text">Se déconnecter</span>
                </Button>
            </div>
        </PageContainerAuth>
    );
}